// Canonical catalog of approvable document types. The matrix admin offers these;
// resolveChain accepts any string, but the UI is driven by this catalog.
export const DOC_TYPE_CATALOG = [
    { code: 'JV', label: 'ใบสำคัญทั่วไป (Journal Voucher)' },
    { code: 'PV', label: 'ใบสำคัญจ่าย (Payment Voucher)' },
    { code: 'RV', label: 'ใบสำคัญรับ (Receipt Voucher)' },
    { code: 'PR', label: 'ใบขอเบิก/ขอจ่าย (Payment Request)' },
];
//# sourceMappingURL=doc-types.js.map